import styled from 'styled-components';
import { useState } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FaInfoCircle, FaTimes } from "react-icons/fa";

interface AjudinhaProps {
    texto: string;
    ehDestacado?: boolean;
    autoCloseTime?: number;
}

const AjudinhaWrapper = styled.span`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-bottom: 6px;
    font-size: 0.9rem;
    font-weight: bold;
    color: #fff;
    background-color: #1F467E;
    text-align: center;
    user-select: none;

    &:hover {
        background-color: #55a4f8;
    }
`;

const AjudinhaIcon = styled(FaInfoCircle)`
    cursor: pointer;
    color: #1F467E; 
    font-size: 1.3rem; 
`;

const StyledTooltip = styled(Tooltip)`
    padding: 12px; /* Aumentei o padding para afastar o texto das bordas */
    color: #000000;
    font-size: 16px;
    border-radius: 8px;
    text-align: center;
    background-color: rgba(240, 240, 240, 1);
    border: 1px solid rgba(204, 204, 204, 0.5);
    position: relative; /* Para posicionar o botão de fechar corretamente */

    .tooltip-inner {
        border: none;
        color: inherit;
        border-radius: 8px;
        padding: inherit;
        background-color: transparent;
    }
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 10px; /* Aumentei o right para afastar o botão da borda direita */
    top: 10px; /* Aumentei o top para afastar o botão da borda superior */
    color: #000;
    font-size: 14px; /* Tamanho do ícone de fechar */
    padding: 4px; /* Espaçamento interno para melhorar a área de clique */
`;

function Ajudinha(props: AjudinhaProps) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    let timeout: ReturnType<typeof setTimeout>;

    const handleShowTooltip = () => {
        setShowTooltip(true);
        setIsClicked(true);

        const autoCloseTime = props.autoCloseTime || 3;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setShowTooltip(false);
            setIsClicked(false);
        }, autoCloseTime * 1000);
    };

    const handleMouseEnter = () => {
        if (!isClicked) {
            setShowTooltip(true);
        }
    };

    const handleMouseLeave = () => {
        if (!isClicked) {
            setShowTooltip(false);
        }
    };

    const handleCloseTooltip = () => {
        setShowTooltip(false);
        setIsClicked(false);
        clearTimeout(timeout);
    };

    return (
        <OverlayTrigger
            placement="auto"
            show={showTooltip}
            overlay={
                <StyledTooltip placement="auto" id="ajudinha-tooltip">
                    <CloseButton onClick={handleCloseTooltip}>
                        <FaTimes />
                    </CloseButton>
                    {props.texto}
                </StyledTooltip>
            }
        >
            {props.ehDestacado ? (
                <AjudinhaIcon
                    onClick={handleShowTooltip}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                />
            ) : (
                <AjudinhaWrapper
                    onClick={handleShowTooltip}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    ?
                </AjudinhaWrapper>
            )}
        </OverlayTrigger>
    );
}

export default Ajudinha;